module.exports = __webpack_public_path__ + "static/media/tire.b88a64f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/gameOceanCleanup/tire.png
// module id = 2550
// module chunks = 0